<template>
	<div v-if="isLegacy" id="legacy-app" class="legacy-app relative">
		<Navbar></Navbar>
		<router-view></router-view>
		<Footer></Footer>
	</div>
	<router-view v-else></router-view>
</template>

<script>
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
export default {
	components: {
		Navbar,
		Footer
	},
	computed: {
		isLegacy() {
			return !!this.$route.meta.legacy;
		}
	},
	mounted() {
		var href = window.location.href;

		if (href.indexOf("/page/mobile") != -1) {
			var navs = document.getElementsByClassName("hide-nav");
			try {
				for (var i = 0; i < navs.length; i++) {
					navs[i].style.display = "none";
				}
			} catch (e) {}
			var footer = document.getElementById("footer");
			if (footer != null) {
				footer.style.display = "none";
			}
			var chatbot_label = document.getElementById("chatbot_label");
			if (chatbot_label != null) {
				chatbot_label.style.display = "none";
			}
		}
	}
};
</script>
<style>
.legacy-app {
	font-family: "Geist", sans-serif;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	color: #2c3e50;
	background-color: #f6f3eb;
	min-height: 100vh;
}

.geist-font {
	font-family: "Geist", sans-serif;
	font-optical-sizing: auto;
	font-style: normal;
}
.bangers-regular {
	font-family: "Bangers", system-ui;
	font-weight: 400;
	font-style: normal;
}
</style>
